import React, { useState } from 'react';
import DataRows from './DataRows';
import { RadioButton } from '@adserve/adserve-react-components';

const PerformanceByTimeTable = ({ onChange, data, showDetail, readOnly, onEdit, onDelete, onLinkClick, ...props }) => {
    const headHeight = 30;
    const visibleActiveRows = 6; // ASSP-7703 was 7
    const rowHeight = 35;
    const totalHeight = (rowHeight + 2) * visibleActiveRows + headHeight; // ASSP-7703 was rowHeight * visibleActiveRows + headHeight;
    const [displayField, setDisplayField] = useState('Impacts');
    const radioTextStyle = {
        marginLeft: 5.5,
        marginRight: 8,
        fontSize: 15
    };
    /**
     * Generates the gridTemplateAreas css to fit the data
     */
    const generateGridTemplateAreas = () => {
        // active grid headers
        let retVal = "'timeSlotH deliveredH bookedH trackingH'";
        // active grid data
        console.log('min rows ', data?.length + 2);
        for (let i = 0; i < data?.length + 2; i++) {
            retVal = `
                ${retVal}
                'timeSlot${i} delivered${i} booked${i} tracking${i}  ${i < visibleActiveRows ? '' : '.'}'
            `;
        }

        return retVal;
    };

    return (
        <div {...props}>
            <div style={{ display: 'flex', marginBottom: 18 }}>
                <div onClick={() => setDisplayField('Impacts')} style={{ display: 'flex', cursor: 'pointer' }}>
                    <RadioButton width={16} height={16} value={displayField === 'Impacts'} />
                    <span style={radioTextStyle}> {window.translate('Impacts')} </span>
                </div>

                <div onClick={() => setDisplayField('Spots')} style={{ display: 'flex', cursor: 'pointer' }}>
                    <RadioButton width={16} height={16} value={displayField === 'Spots'} />
                    <span style={radioTextStyle}> {window.translate('Spots')} </span>
                </div>

                <div onClick={() => setDisplayField('Budget')} style={{ display: 'flex', cursor: 'pointer' }}>
                    <RadioButton width={16} height={16} value={displayField === 'Budget'} />
                    <span style={radioTextStyle}> {window.translate('Budget')} </span>
                </div>
            </div>
            <div
                style={{
                    display: 'grid',
                    boxSizing: 'border-box',
                    backgroundColor: '#ffffff',
                    overflowX: 'hidden',
                    height: totalHeight,
                    overflowY: 'auto' // ASSP-7703 was 'scroll'
                }}
            >
                <DataRows
                    displayField={displayField}
                    data={data}
                    onChange={onChange}
                    rowHeight={rowHeight}
                    visibleRows={visibleActiveRows}
                    readOnly={readOnly}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onLinkClick={onLinkClick}
                />
            </div>
        </div>
    );
};

export default PerformanceByTimeTable;
